import { FC } from "react";

interface SimpleTitleProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

const SimpleTitle: FC<SimpleTitleProps> = ({ title, className, children }) => {
  return (
    <h6 className={className ?? "mt-3 mb-2"}>
      <b>{title ?? children}</b>
    </h6>
  );
};

export default SimpleTitle;
